import { uuid } from '@zyno-io/vue-foundation';
import { ref } from 'vue';

import { OtelState } from './otel';

// Lightweight, dependency-free signal for "is this a workstation session", set by the
// full-app State (global.ts) once known. Lives here rather than in global.ts so lean
// bundles (e.g. the embedded CX app, or the shared Loader) can read it without statically
// pulling global.ts's API clients and services. Defaults false (CX is never a workstation).
export const isWorkstationRef = ref(false);

// Whether the running app is an embedded, customer-facing surface (the CX app) rather than the full
// ZynoSuite app. Set once at bootstrap by the embedded entry (cx.main.ts); both entries share one
// Vite build so import.meta.env can't distinguish them. Lets shared components adapt without each
// call site opting in — e.g. the Loader hides its playful escalating emoji in customer-facing CX.
export const isEmbeddedApp = ref(false);

// The active tenant's CRM "primary contact type" (e.g. 'company'), mirrored from the full-app State
// (global.ts). Lives here so lean cross-module helpers — like crmGetContactDisplayName in
// modules/crm/exports/contact.helpers, which the embedded CX forms use — can read it without pulling
// global.ts in. Null when unknown (e.g. in CX, which never loads tenant configuration).
export const crmPrimaryContactTypeRef = ref<string | null>(null);

// The active tenant's id, mirrored from the full-app State (global.ts) so lean low-level services —
// like sw.manager, which the embedded CX app reaches via the idle/update helpers — can read it
// without pulling global.ts in. Null when there's no active tenant (e.g. in CX).
export const activeTenantIdRef = ref<string | null>(null);

export class SharedState {
    constructor() {
        OtelState.browserId = this.browserId;
    }

    get browserId() {
        let browserId = window.localStorage.getItem('zs:browserId');
        if (!browserId) {
            browserId = uuid();
            window.localStorage.setItem('zs:browserId', browserId);
        }
        return browserId;
    }
}
